<template>
  <div class="row">
    <div class="col-xs-12 col-md-12">
      <card header-text="Tus Inspiradores">
        <template v-slot:card-header>
          <router-link class="btn btn-action btn-small btn-success"
            :to="{ name: 'crear-inspirador' }"
          >
            <i class="fa fa-plus"></i>&nbsp;<span>Nuevo Inspirador</span>
          </router-link>
        </template>
        <div class="row">
          <div class="col-md-6">
            <label for="numeroIdentidad" class="input-group input-group-sm mb-3">
                <small class="mr-3 align-self-center">CC/TI/NUIP/RC</small>
              <input id="numeroIdentidad" type="number" class="form-control" v-model.number="queryParams.filters.numeroIdentificacion">
              <div class="input-group-append" id="button-addon4">
                <button class="btn btn-small btn-outline-secondary"
                  @click="queryParams.filters.numeroIdentificacion ? cargarInspiradores() : null"
                >
                  Buscar
                </button>
                <button
                  class="btn btn-small btn-outline-secondary"
                  type="button"
                  @click="queryParams.filters.numeroIdentificacion = ''; cargarInspiradores()"
                >
                  Limpiar
                </button>
              </div>
            </label>
          </div>
          <div class="col-md-6">
            <label for="correo" class="input-group input-group-sm mb-3">
              <small class="mr-3 align-self-center">Email</small>
              <input id="correo" type="text" class="form-control" v-model.number="queryParams.filters.correo">
              <div class="input-group-append" id="button-addon4">
                <button class="btn btn-small btn-outline-secondary"
                  type="button"
                  @click="queryParams.filters.correo ? cargarInspiradores() : null"
                >
                  Buscar
                </button>
                <button
                  class="btn btn-small btn-outline-secondary"
                  type="button"
                    @click="queryParams.filters.correo = ''; cargarInspiradores()"
                >
                  Limpiar
                </button>
              </div>
            </label>
          </div>
        </div>
        <div class="table-responsive">
          <table class="table table-striped first-td-padding">
            <thead>
              <tr>
                <td>Identificación</td>
                <td>Nombres</td>
                <td>Apellidos</td>
                <td>Entidad</td>
                <td>Teléfono</td>
                <td>Dirección</td>
                <td>Departamento</td>
                <td>Municipio</td>
                <td align="center">Acciones</td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(inspirador, key) in inspiradores" :key="key">
                <td>{{ inspirador.doc.numeroIdentificacion }}</td>
                <td>{{ inspirador.doc.nombres }}</td>
                <td>{{ inspirador.doc.apellidos }}</td>
                <td>{{ inspirador.doc.tipoLinea }}</td>
                <td>{{ inspirador.doc.telefono }}</td>
                <td>{{ inspirador.doc.direccion }}</td>
                <td>{{ inspirador.doc.departamento.nombre }}</td>
                <td>{{ inspirador.doc.municipio.nombre || inspirador.doc.municipio.nombreMunicipio }}</td>
                <td align="center">
                  <button
                    @click="verInspiradorAction(inspirador)"
                    title="Ver información de inspirador"
                    class="btn btn-small btn-action btn-info"
                  >
                    <i class="fa fa-eye"></i>&nbsp;
                    <span>Ver</span>
                  </button>
                  <router-link class="btn btn-small btn-action btn-warning"
                    title="Editar inspirador"
                    :to="{ name: 'editar-inspirador', params: {id: inspirador.id}}"
                  >
                    <i class="fa fa-edit"></i>&nbsp;<span>Editar</span>
                  </router-link>
                </td>
              </tr>
            </tbody>
          </table>
          <paginate
            :pageCount="pageCount"
            :clickHandler="handlerPaginate"
            :prevText="'Anterior'"
            :nextText="'Siguiente'"
            :containerClass="'pagination'"
            :page-class="'page-item'"
            :page-link-class="'page-link'"
            :prev-link-class="'page-link'"
            :next-link-class="'page-link'"
          >
          </paginate>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import { obtenerInspiradores } from '../../api/admin'
import { } from '../../api/auth'
import { mapState, mapMutations } from 'vuex'
import paginate from 'vuejs-paginate'

export default {
  components: { paginate },
  data () {
    return {
      inspiradores: [],
      totalRecords: 0,
      queryParams: {
        page: 1,
        filters: {
          idMerani: undefined
        }
      }
    }
  },
  mounted () {
    this.obtenerInspiradores()
  },
  methods: {
    verInspiradorAction (inspirador) {
      this.setInspirador(inspirador.doc)
      this.$router.push({ name: 'ver-inspirador', params: { id: inspirador.id } })
    },
    ...mapMutations('merani', [
      'setInspirador'
    ]),
    async cargarInspiradores () {
      this.$forceUpdate()
      const data = await obtenerInspiradores(this.queryParams)
      this.inspiradores = data.results
      this.totalRecords = data.total
    },
    handlerPaginate (page) {
      this.queryParams.page = page
      this.cargarInspiradores()
    },
    async obtenerInspiradores () {
      this.queryParams.filters.idMerani = this.token
      this.cargarInspiradores()
    }
  },
  computed: {
    ...mapState('user', [
      'token'
    ]),
    pageCount () {
      return Math.ceil(this.totalRecords / 20)
    }
  }
}
</script>
<style lang="scss">
  .table thead tr{
    color: #007bff;
  }
  .error-icon{
    color: #e34a4a;
  }
  .success-icon {
    display: inline-block;
    color: #4ae387;
  }
  .table-sm th, .table-sm td{
    padding: .7rem;
  }
  .color-icon-label-table {
    td:first-child {
      width: 1rem;
    }
  }
  .btn-small {
    font-size: 12px;
  }
  .btn-action {
    margin-right: 10px;
    padding: 4px 8px;
    &:last-child {
      margin-right: 0;
    }
    @media screen and (max-width: 992px) {
      span {
        display: none;
      }
    }
  }
</style>
